<template>
  <select class="po-filters__select select select_filter-round">
    <slot></slot>
  </select>
</template>

<script>

import $ from 'jquery'; 
import 'select2';

export default {
  name: 'Select2',
  props: ['options', 'value'],
  mounted: function() {
    var vm = this
    $(this.$el)
    .select2({
        minimumResultsForSearch: 20,
        data: this.options
    })
    .val(this.value)
    .trigger('change')
    .on('change', function () {
      vm.$emit('input', this.value)
    })
  },
  watch: {
    value: function (value) {
      $(this.$el)
        .val(value)
        .trigger('change')
    },
    options: function (options) {
      $(this.$el).empty().select2({ data: options })
    }
  },
  destroyed: function () {
    $(this.$el).off().select2('destroy')
  }
}
</script>
<style lang="scss">

$f-base: GothamPro, sans-serif;
$c-white: #ffffff;
$c-text: #010615;
$c-border-color: #cacaca;
$c-main-color: #fdc500;
$c-header-border: rgba(1, 6, 21, .3);
$c-bg-gray: #eceff1;

.select2 {
  margin-left: 30px;
  display: none;
}
@media screen and (max-width: 1440px) {
  .select2 {
    display: inline-block;
  }
}

.select2-container {
  min-width: 150px;
  background-color: transparent;
}

.select2-container--default .select2-selection--single {
  border-radius: 15px;
  height: 30px;
  line-height: 30px;
  background-color: $c-border-color;
  padding-left: 20px;
  border: none;
  color: $c-text;
  outline: none;
}

.select2-container--open .select2-dropdown--below {
  border-radius: 15px 15px 0 0;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
  color: $c-text;
  line-height: 30px;
}

.select2-container--default .select2-results__option[aria-selected=true] {
  background-color: $c-border-color;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  color: $c-text;
  background-color: $c-bg-gray;
}

.select2-dropdown {
  margin-top: 0;
  color: $c-text;
  border: none;
  border-radius: 0;
  box-shadow: none;
  background-color: transparent ;
  padding-top: 30px;
  margin-top: -30px;
  border-radius: 15px 15px 0 0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .15);


  &.select2-drop-active {
    border: none;
    border-top: 1px solid $c-border-color;
  }

  .select2-results {
    max-height: 400px;
    margin: 0;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      min-height: 60px;
      padding: 0 20px;
      cursor: pointer;
      transition: .5s;
      box-sizing: border-box;
        width: 100%;
        min-height: 30px;
        padding: 8px 8px 8px 20px;
        border-top: 1px solid $c-border-color;
        background-color: $c-border-color;
    }
  }
}
</style>